var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.DataTable,{attrs:{"data-testid":"planned-allocation-table","columns":_setup.columnsTable,"data":_setup.tableData,"show-divider":"","has-interaction":false,"status":_setup.dataTableStatus},on:{"on-sort":_setup.sortTable}})
}
var staticRenderFns = []

export { render, staticRenderFns }